<template>
  <div>
    <v-row>
      <v-col cols="12" md="6" offset-md="3">
        <form @submit.prevent="save">
          <DateSelector
            :date="form.date"
            @change="updateDate"
          />
          <FormErrors
            v-if="$v.form.$error && (!$v.form.date.required)"
          >
            <FormErrorsLine v-if="!$v.form.date.required" text="Polje je obvezno" />
          </FormErrors>

          <v-text-field
            v-if="form.delivery_document"
            v-model="form.delivery_document"
            label="Št. inventure *"
          ></v-text-field>
          <!-- <FormErrors
            v-if="$v.form.$error && (!$v.form.delivery_document.required)"
          >
            <FormErrorsLine v-if="!$v.form.delivery_document.required" text="Polje je obvezno" />
          </FormErrors> -->
          <v-textarea
            v-model="form.comment"
            label="Komentar"
          >
          </v-textarea>
          <v-btn v-if="!skrij" type="submit" class="float-right white--text" color="#0F998E">
            Naprej
          </v-btn>
          <!-- <v-btn v-if="!modalView && isNewInventoryForm" type="button" class="float-right mr-4" @click="saveAndRepeat">Shrani in dodaj novo</v-btn> -->
          <v-btn v-if="!skrij" text type="button" class="float-right mr-4" @click="cancel">Prekliči</v-btn>
          <div style="display: none;">
            {{spremenjenDatum}}
            {{spremenjenoStPrevzemnice}}
            {{spremenjenoKomentar}}
          </div>
        </form>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import moment from 'moment'
import { required } from 'vuelidate/lib/validators'
import FormErrors from '@/components/FormErrors'
import FormErrorsLine from '@/components/FormErrorsLine'
import DateSelector from './DateSelector.vue'

export default {
  components: {
    FormErrors,
    FormErrorsLine,
    DateSelector,
  },
  props: {
    inventoryForm: {
      default: () => {},
      type: Object
    },
    skrij: {
      required: false,
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      localStaraForm: null,
      emptyForm: {
        date: moment().format('YYYY-MM-DD'),
        delivery_document: null,
        comment: null
      },
      form: {},
      dataFetched: false,
      razlog: null
    }
  },
  validations: {
    form: {
      date: {
        required
      }
    }
  },
  computed: {
    isNewInventoryForm () {
      return !this.inventoryForm || Object.values(this.inventoryForm).length === 0
    },
    spremenjenDatum () {
      return this.localStaraForm ? this.form.date !== this.localStaraForm.date : false
    },
    spremenjenoStPrevzemnice () {
      return this.localStaraForm ? this.form.delivery_document !== this.localStaraForm.delivery_document : false
    },
    spremenjenoKomentar () {
      return this.localStaraForm ? this.form.comment !== this.localStaraForm.comment : false
    }
  },
  methods: {
    save () {
      this.$v.$touch()
      console.log(this.form)
      if (!this.$v.form.$error) {
        this.$emit('save', { data: this.form })
      }
    },
    saveAndRepeat () {
      this.$v.$touch()
      if (!this.$v.form.$error) {
        this.$emit('save', { data: this.form, repeat: true })
      }
    },
    clearForm () {
      this.form = { ...this.emptyForm }
      this.$v.$reset()
    },
    cancel () {
      this.$emit('cancel')
    },
    updateDate ({ date }) {
      this.form.date = date
    },
  },
  mounted () {
    this.$nextTick(() => {
      this.dataFetched = true
    })
  },
  created () {
    this.form = { ...this.emptyForm }
    if (!this.isNewInventoryForm) {
      this.form = { ...this.form, ...this.inventoryForm }
    }
    this.localStaraForm = { ...this.form }
    this.localStaraForm.comment = this.localStaraForm.comment === null ? '' : this.localStaraForm.comment
  },
  watch: {
    spremenjenDatum (sprememba) {
      const razlog = 'spremenjenDatum'
      if ((this.dataFetched && this.razlog === razlog) || this.razlog === null) {
        this.razlog = razlog
        this.$emit('sprememba')
      }
    },
    spremenjenoStPrevzemnice (sprememba) {
      const razlog = 'spremenjenStPrevzemnice'
      if ((this.dataFetched && this.razlog === razlog) || this.razlog === null) {
        this.razlog = razlog
        this.$emit('sprememba')
      }
    },
    spremenjenoKomentar (sprememba) {
      const razlog = 'spremenjenKomentar'
      if ((this.dataFetched && this.razlog === razlog) || this.razlog === null) {
        this.razlog = razlog
        this.$emit('sprememba')
      }
    }
  }
}
</script>
